import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-specs",
  "use": "icon-soc-l1-mall-specs-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-specs\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M224 160h448l128 128v576H224V160zm64 64v576h448V320H608V224H288zm384 0v64h64l-64-64z\" />\r\n  <path d=\"M352 416h320v48H352v-48zm0 96h320v48H352v-48zm0 96h224v48H352v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-specs.svg
// module id = 9pVI
// module chunks = 491